/** SF-4651 step 1: the prospect's web address. */
import { Form, Input, Typography } from 'antd';

export interface WebAddressStepProps {
  value: string;
  error: string | null;
  onChange: (value: string) => void;
}

export const WebAddressStep: React.FC<WebAddressStepProps> = ({ value, error, onChange }) => (
  <Form layout="vertical">
    <Typography.Paragraph type="secondary">
      Eva reads the prospect’s site for their name, logo, colours and what they do.
    </Typography.Paragraph>
    <Form.Item
      label="Prospect’s web address"
      validateStatus={error ? 'error' : undefined}
      help={error ?? 'For example greggs.co.uk'}
      htmlFor="demo-domain"
    >
      <Input
        id="demo-domain"
        value={value}
        placeholder="greggs.co.uk"
        autoComplete="off"
        onChange={(e) => onChange(e.target.value)}
      />
    </Form.Item>
  </Form>
);
